export { default } from './ExpertiseIncluded';